import type { BrandConfig } from './types';
import meta from './zuadaria.meta.json';

/** Marca Zuadaria (clube de comédia) — opt-in via brandKey / host. */
export const zuadariaBrand: BrandConfig = {
  key: 'zuadaria',
  displayName: meta.displayName,
  logoUrl: meta.logoUrl,
  favicons: meta.favicons,
  documentTitle: meta.documentTitle,
  og: meta.og,
  landingTemplate: 'comedy_club',
  publicPage: {
    flatPage: true,
    pageBg: '#F7F5F3',
    pageBgDeep: '#F7F5F3',
    text: '#1A1515',
    textSoft: '#6A6161',
    heading: '#1A1515',
    accent: '#8F3A3A',
    accentSoft: 'rgba(143, 58, 58, 0.07)',
    border: 'rgba(26, 21, 21, 0.1)',
    surface: '#FFFFFF',
    surfaceSoft: '#FFFFFF',
    cardShadow: '0 10px 28px rgba(26, 21, 21, 0.06)',
    ctaStart: '#B84D4D',
    ctaEnd: '#9A3D3D',
    ctaShadow: 'rgba(184, 77, 77, 0.22)',
  },
  copy: {
    auth: {
      loginTitle: 'Entrar na Zuadaria',
      loginSubtitle: 'Acesse o painel para gerenciar shows e ingressos.',
      footerShort: `© ${new Date().getFullYear()} Zuadaria`,
      footerWide: `© ${new Date().getFullYear()} Zuadaria. Todos os direitos reservados.`,
      forgotPasswordHint:
        'da plataforma (não o e-mail institucional do clube, se for diferente).',
    },
    chrome: {
      sidebarTitle: 'Zuadaria',
      sidebarSubtitle: 'Painel da casa',
      footerCopyright: `© ${new Date().getFullYear()} Zuadaria`,
      showAcutisQuote: false,
      showSupportEmail: true,
      supportEmail: 'contato@zuadaria.com.br',
      supportInstagram: 'clubezuadaria',
    },
    eventForm: {
      titlePlaceholder: 'Ex: Carlos Pulico — Especial São João',
      slugPlaceholder: 'ex: carlos-pulico-especial',
      slugHelper: 'Esse identificador será usado na URL do show. Ex: /carlos-pulico-especial',
      locationPlaceholder: 'Ex: Zuadaria Clube de Comédia',
      descriptionPlaceholder:
        'Descreva o show: artista, estilo, duração, classificação e o que o público pode esperar...',
      contactEmailPlaceholder: 'Ex: contato@zuadaria.com.br',
      promoLinkPlaceholder: 'Ex.: WhatsApp do grupo, Instagram do artista',
      categories: [
        { value: 'standup', label: 'Stand-up' },
        { value: 'festa_festival_show', label: 'Festa, festival ou show' },
        { value: 'networking', label: 'Eventos de networking' },
        { value: 'palestra_congresso', label: 'Palestras, congressos ou seminários' },
        { value: 'passeio_excursao', label: 'Passeios ou excursões' },
        { value: 'competicao_torneio', label: 'Competição ou torneio' },
        { value: 'corrida', label: 'Corrida' },
        { value: 'curso_workshop', label: 'Curso, aula, treinamento ou workshop' },
        { value: 'espetaculo', label: 'Espetáculos' },
        { value: 'feira_exposicao', label: 'Feira ou exposição' },
        { value: 'other', label: 'Outro' },
        { value: 'none', label: 'Sem categoria' },
      ],
      categoryAliases: {
        show: 'festa_festival_show',
        festival: 'festa_festival_show',
        workshop: 'curso_workshop',
        encontro: 'networking',
        open_mic: 'standup',
        especial: 'standup',
        improv: 'standup',
      },
      steps: [
        { label: 'Informações Básicas', description: 'Detalhes essenciais do show' },
        { label: 'Ingressos e Pagamentos', description: 'Preços e formas de pagamento' },
        { label: 'Dados da compra', description: 'Campos e regras do checkout' },
        { label: 'Página do show', description: 'Personalize a aparência' },
      ],
      registrationSettingsTitle: 'Configurações de Compra',
      registrationSettingsHelp: 'Configure como o público vai comprar o ingresso',
      registrationDeadlineLabel: 'Prazo de Compra',
    },
    home: {
      chip: 'PRÓXIMOS SHOWS',
      title: 'Seu próximo show',
      titleAccent: 'está aqui',
      subtitle:
        'Stand-up, especiais e noites de risada no Zuadaria Clube de Comédia — tudo em um só lugar.',
      ctaExplore: 'Ver shows',
      ctaSecondary: 'Cadastrar show',
      ctaSecondaryHref: '/cadastro-paroquia',
      eventsChip: 'SHOWS EM DESTAQUE',
      eventsTitle: 'Próximos shows',
      eventsSubtitle: 'Escolhe o próximo e vem curtir uma noite de risadas no Zuadaria.',
      eventsCountLabel: 'Shows',
      emptyTitle: 'Nenhum show encontrado',
      emptySubtitle: 'Novos shows serão exibidos aqui em breve.',
      fallbackCover: '/brands/zuadaria-apple-touch.png',
    },
  },
};
